
//閹虫帒濮炴潪锟�
const lazyElements = document.querySelectorAll("img.lazy-2nd, video.lazy-2nd, iframe.lazy-2nd");
const observer_new = new IntersectionObserver((entries, obs) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			const element = entry.target;
			const dataSrc = element.getAttribute("data-lazysrc");
			element.setAttribute("src", dataSrc);
			obs.unobserve(element);
			let realWidth,realHeight;
			if(element.tagName === 'IMG') {
				element.onload = function() {
					realWidth = element.naturalWidth;
					realHeight = element.naturalHeight;
					element.setAttribute("style",`aspect-ratio: auto ${realWidth} / ${realHeight}`);
				};
			}
		}
	});
});

lazyElements.forEach((element) => {
	observer_new.observe(element);
});
const $WindowW = $(window).width();
$('img.lazy-2nd').each(function (i) {
	const img = $(this);
	const imgW = $(img).attr('width');
	const imgH = $(img).attr('height');
	if(imgW && imgH) {
		$(img).css('aspect-ratio',`auto ${imgW} / ${imgH}`);
	}else  {
		if($WindowW < 750) {
			$(img).css('aspect-ratio',`1 / 1`);
		}else {
			$(img).css('aspect-ratio',`16 / 9`);
		}
	}
})
